module.exports = __webpack_public_path__ + "img/album01_08.f69ddc0f.jpg";